import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("创建客户")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("更新插入客户")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, {userCfig} from '@/global_mixin/tableMixin'
import { formatTime } from '@/utils/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { 
  'POST/order/receivable/clients': fetchList,
  // 更新客户维护
  'POST/order/receivable/clients/update': updateApi,
  // 创建客户维护
  'POST/order/receivable/clients/save': saveClientsApi,
  // 删除客户维护
  'DELETE/order/receivable/clients/delete/{id}': deleteClientsApi,
  // 更新插入客户
  'POST/order/receivable/create_client': create_clientApi,
  // 查看客户详情
  'PUT/order/receivable/clients/list': clientsListApi,
  // 客户维护编辑
  'PUT/order/receivable/clients/country/update': editApi,
  // 国别列表
  'GET/order/receivable/clients/countries': countriesListApi,
  // 开票公司列表
  'GET/order/invoice_companies': invoice_companiesApi,
  // 客户维护导出
  'POST/order/receivable/clients/export': exportClientsApi
} = Api
let {currencyOption} = PaymentModuleUtils

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let countrieList: any = ref([])
let companyInvice = ref([])
onBeforeMount(() => {
  countriesListApi().then((rep: any) => {
    countrieList.value = rep.map((label: string) => ({ label, id: label }))
  })

  invoice_companiesApi().then((rep: any) => {
    companyInvice.value = rep.map((com: string) => {
      return { label: com, id: com }
    }).concat([{label: '空白', id: '空白'}])
  })
})


const searchConfig = ref([
  {
    label: '客户ID',
    value: '',
    upKey: 'customerId'
  },
  {
    label: '客户名称',
    value: '',
    upKey: 'customerName'
  },
  /* {
    label: '国家',
    value: '',
    upKey: 'country'
  }, */
  {
    type: 'SELECT',
    label: '国家',
    value: '',
    upKey: 'country',
    options: countrieList,
    props: {clearable: true, placeholder: '请选择国家',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '境内外',
    value: '',
    upKey: 'domestic',
    options: [
      { label: '境内', id: true},
      { label: '境外', id: false },
    ],
    props: {clearable: true, placeholder: '请选择境内外',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    label: 'CO2销售',
    value: '',
    upKey: 'CM'
  },
  userCfig({
    label: '销售',
    upKey: 'saleId',
    props: {clearable: true},
  }),
  {
    type: 'SELECT',
    label: '是否发起询证',
    value: '',
    upKey: 'needConfirm',
    options: [
      { label: '是', id: true},
      { label: '否', id: false },
    ],
    props: {clearable: true, placeholder: '请选择是否发起询证',},
    seleProps: { label: 'label', valueName: 'id', },
  },
])

// 添加
const addConfig = ref([
  {
    label: '客户',
    value: '',
    upKey: 'client',
    props: {},
    rule: [
      { required: true, message: '请输入客户', trigger: 'change' },
    ],
  },
  {
    label: '公司',
    value: '',
    upKey: 'invoiceCompany',
    props: {},
    rule: [
      { required: true, message: '请输入客户', trigger: 'change' },
    ],
  },
  {
    type: 'SELECT',
    label: '币种',
    value: '',
    upKey: 'currency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    label: '财务确认客户',
    value: '',
    upKey: 'financialName',
    props: {},
  },
  {
    label: '对方联系人',
    value: '',
    upKey: 'contacts',
    props: {},
  },
  {
    label: '邮件地址',
    value: '',
    upKey: 'mail',
    props: {},
  },
  {
    label: '特殊备注',
    value: '',
    upKey: 'remarks',
    props: {},
  },
  {
    type: 'SELECT',
    label: '询证函主体',
    value: '',
    upKey: 'confirmationCompany',
    options: companyInvice,
    props: {clearable: true, placeholder: '请选择询证函主体'},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    label: '客户类型',
    value: '',
    upKey: 'customerType'
  }
])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    await saveClientsApi(params)
    addFg.value = false
    ElMessage.success('成功')
  })
}

// 编辑
const editFg  = ref<boolean>(false)
const editConfig = ref([
  {
    type: 'SELECT',
    label: '国家',
    value: '',
    upKey: 'country',
    options: countrieList,
    props: {clearable: true, placeholder: '请选择境内外',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  userCfig({
    label: '销售',
    upKey: 'saleId',
    props: {clearable: true},
  }),
  {
    label: '客户类型',
    value: '',
    upKey: 'customerType'
  }
])
const editHandle = (row: any) => {
  MI_modifyForm(row, editConfig, editFg, async (params: object) => {
    await editApi({...params, client: row.client}, { contentType: 'formData'})
    ElMessage.success('编辑成功')
    editFg.value = false
    fetchData(MI_params)
  })
}


// 更新插入客户
const insertFg = ref<boolean>(false)
const insertConfig = ref([
  {
    type: 'SELECT',
    label: '时间类型',
    value: '',
    upKey: 'dateType',
    options: [
      { label: '月份', id: 'month' },
      { label: '季度', id: 'quarter' },
      { label: '年份', id: 'year' },
    ],
    props: { clearable: true, placeholder: '请选择类型'},
    seleProps: {}
  },
  {
    type: "TIME",
    label: "时间范围",
    value: [],
    upKey: 'range',
    // upProps: { startKey: 'from', endKey: 'to', },
    props: {
      type: 'daterange',
      clearable: true,
    }
  }, 
])
const insertHandle = () => {
  MI_modifyForm({}, insertConfig, insertFg, async(params: any) => {
    await create_clientApi({
      ...params,
      dateRange: {
        from: params.range[0],
        to: params.range[1],
      }
    })
    insertFg.value = false
    ElMessage.success('成功')
    fetchData(MI_params)
  })
}

// 详情
const { 
  MI_tableData: detailsData, fetchData: detailsFetch, page: detailsPage, size: detailsSize, MI_params: detailsParams,
  MI_total: detailsTotal, MI_pageChange: detailsPageCg,  MI_identify: detailsIdentify, MI_sizeChange: detailsSizeCg
} = new tbMix(clientsListApi)
const detailsFg = ref<boolean>(false)

const showDeatils = (row: any) => {
  detailsFg.value = true
  detailsFetch({
    client: row.client
  }, { contentType: 'formData'})
}

// 详情修改
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => {
  MI_modifyForm(row, addConfig, modifyFg, async(params: any) => {
    await updateApi({...params, id: row.id})
    modifyFg.value = false
    ElMessage.success('更新成功')
    detailsFetch(detailsParams, { contentType: 'formData'})
  })
}

// 详情删除
const delHandle = (row: any) => { 
  ElMessageBox.confirm(
    '是否删除?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
      return deleteClientsApi({id: row.id})
    })
    .then(() => {
      ElMessage.success('删除成功')
      detailsFetch(detailsParams, { contentType: 'formData'})
    })
    .catch(() => { })
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_space = _resolveComponent("el-space")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "客户维护-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              initSearch: true,
              title: true,
              searchConfig: searchConfig.value
            }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (insertHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_eptBtn, {
        exportFn: _unref(exportClientsApi),
        exportText: '导出',
        exportParam: _unref(MI_params)
      }, null, 8, ["exportFn", "exportParam"]), [
        [_directive_permission, 'Export']
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "客户ID(点击查看详情)",
          prop: "client",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: _withModifiers(($event: any) => (showDeatils(row)), ["stop"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.client), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名称",
          prop: "customerName"
        }),
        _createVNode(_component_el_table_column, {
          label: "co2销售",
          prop: "CM"
        }),
        _createVNode(_component_el_table_column, {
          label: "销售",
          prop: "sale"
        }),
        _createVNode(_component_el_table_column, {
          label: "国家",
          prop: "country"
        }),
        _createVNode(_component_el_table_column, {
          label: "境内外",
          prop: "domestic",
          formatter: (row) => row.domestic === true ? '境内': '境外'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "是否发起询证",
          prop: "needConfirm",
          formatter: (row) => row.needConfirm === true ? '是': '否'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "客户类型",
          prop: "customerType",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "创建日期",
          prop: "createAt",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (editHandle(row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100 ],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "创建客户",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "更新客户",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑客户",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editFg).value = $event))
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: editConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "更新插入客户",
      modelValue: insertFg.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((insertFg).value = $event))
    }, {
      default: _withCtx(() => [
        (insertFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: insertConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: detailsFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((detailsFg).value = $event)),
      width: "88%",
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_unref(fetchData)(_unref(MI_params)))),
      title: "详情"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(detailsData),
          "max-height": 750 + 'px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "客户",
              prop: "client",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "财务确认的客户",
              prop: "financialName",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "对方联系人",
              prop: "contacts",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "邮件地址",
              prop: "mail",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "联系人(公司)函件地址",
              prop: "address",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "特殊备注",
              prop: "remarks",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "公司",
              prop: "invoiceCompany",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "币种",
              prop: "currency",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "询证函主体",
              prop: "confirmationCompany",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (modifyHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "danger",
                      onClick: ($event: any) => (delHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(detailsIdentify)]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})